module.exports = __webpack_public_path__ + "static/contri_onepercent-049b58653c5644ddf268d85fcb86702d.png";